/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "0.1.0 nightly 2025-06-21",
    versionChannel: "nightly",
    buildDate: "2025-06-21T00:06:51.396Z",
    commitHash: "2b3d3cffd5b6371310d2d9c76cdc91b96afddc40",
};
